import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdCustomersRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-customers',
	path: '/projects/:projectKey/customers',
};
